"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStockTransferByDrugSchema = exports.rejectStockTransferSchema = exports.createStockTransferSchema = exports.stockTransferShape = void 0;
const zod_1 = require("zod");
exports.stockTransferShape = {
    branchId: zod_1.z.string().uuid(),
    fromLocationId: zod_1.z.string().uuid(),
    toLocationId: zod_1.z.string().uuid(),
    batchId: zod_1.z.string().uuid(),
    quantity: zod_1.z.number().positive(),
    remarks: zod_1.z.string().optional(),
};
exports.createStockTransferSchema = zod_1.z.object(exports.stockTransferShape);
exports.rejectStockTransferSchema = zod_1.z.object({ reason: zod_1.z.string().min(1) });
/**
 * Reorder flow's own entry point — the caller (the Reorder page) knows
 * WHAT drug and HOW MUCH, not which specific batch to draw from. The
 * server resolves the batch itself (earliest-expiry-first, `stock-
 * batch.repository.ts`'s own `findByDrugAndLocation` FEFO ordering),
 * capping the transferred quantity to what that single best batch
 * actually has available — splitting a shortfall across multiple
 * batches is a disclosed, deliberate out-of-scope simplification this
 * phase, not silently dropped.
 */
exports.createStockTransferByDrugSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    fromLocationId: zod_1.z.string().uuid(),
    toLocationId: zod_1.z.string().uuid(),
    drugId: zod_1.z.string().uuid(),
    quantity: zod_1.z.number().positive(),
    remarks: zod_1.z.string().optional(),
});
//# sourceMappingURL=stock-transfer.schema.js.map